import React from "react";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 2px solid ${theme.colors.gray1};
  box-sizing: border-box;
  border-radius: 16px;
  min-height: 96px;
  padding: ${theme.spacing.unit * 2}px;

  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.gray1};
  }
`;

const LeftItem = styled.div`
  flex-basis: 0%;
  flex-grow: 2;
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.unit * 2}px;
`;

const TitleContainer = styled.div`
  margin-right: ${theme.spacing.unit * 4}px;
`;

const Title = styled.div`
  padding-bottom: ${theme.spacing.unit * 1}px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 120%;
`;

const Subtitle = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
`;

const RightItem = styled.div`
  flex-basis: 0%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const JobPageRow = (props) => {
  const { className, jobPage, button, onClick, href } = props;

  const location =
    jobPage.offices && jobPage.offices.length > 0
      ? jobPage.offices.map((o) => o.name).join(", ")
      : jobPage.location;

  let teamAndDepartment = "";
  if (jobPage.departments[0]?.name !== jobPage.topDepartment?.name) {
    teamAndDepartment = `${jobPage.topDepartment?.name} - ${jobPage.departments[0]?.name}`;
  } else if (jobPage.departments[0]?.name) {
    teamAndDepartment = jobPage.departments[0]?.name;
  }

  return (
    <Container
      className={className}
      onClick={onClick}
      data-testing="job-row"
      as="a"
      href={href}
    >
      <LeftItem>
        <TitleContainer>
          <Title>{jobPage.title}</Title>
          <Subtitle>
            {[location, teamAndDepartment].filter((n) => !!n).join(" - ")}
          </Subtitle>
        </TitleContainer>
      </LeftItem>
      <RightItem>{button}</RightItem>
    </Container>
  );
};

export default JobPageRow;
